import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Price from '../../../utils/Price';

const SelectedProduct = (props) => {
  const selectedProduct = props.selection.find(el => el.productGroupID ===
    props.productGroupID && el.choiceID === props.choiceID &&
    el.productSubgroupID === props.productSubgroupID);

  const placeHolderImages = {
    tshirt: '//thumblr.uniid.it/sitemedia/teamsport/jersey.jpg',
    shorts: '//thumblr.uniid.it/sitemedia/teamsport/shorts.jpg',
    others: '//thumblr.uniid.it/sitemedia/teamsport/socks.jpg',
    default: '//thumblr.uniid.it/sitemedia/teamsport/jersey.jpg',
  };

  const productImageRender = () => {
    if (selectedProduct) {
      const unitPrice = selectedProduct.product.unit_price;
      const rrpPrice = selectedProduct.product.rrp_price;
      return (
        <div>
          <div className="removeItem" onClick={() => props.removeSelection(selectedProduct.product.id, props.productSubgroupID)} role="button" tabIndex="0" style={{ outline: 'none' }} />
          <img className="selected" src={selectedProduct.product.image} alt="selected product" />
          <div className="price">
            <Price
              isTeamSport
              priceNet={unitPrice}
              priceRrp={rrpPrice}
              currency={props.settings.currency}
            />
          </div>
        </div>
      );
    }
    if (props.type === 'others' && props.settings.groupType === 'club') {
        return null;
    }
    if (placeHolderImages[props.type]) {
      return (
        <img src={placeHolderImages[props.type] || placeHolderImages.default} alt="default" />
      );
    }
    return null;
  };

  return (
    <div className="selectedProduct">
      {productImageRender()}
    </div>
  );
};

const mapDispatch = dispatch => (
  {
    removeSelection: (productID, productSubgroupID) => dispatch({
      type: 'REMOVE_SELECTION',
      productID,
      productSubgroupID,
    }),
  }
);

const mapState = state => (
  {
    selection: state.selection,
    settings: state.settings,
  }
);
export default withRouter(connect(mapState, mapDispatch)(SelectedProduct));
